import { useMutation } from '@tanstack/react-query'

import { usersPasswordResetTfaRecoveryCodePost } from '@src/api'
import { DefaultApiUsersPasswordResetTfaRecoveryCodePostRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useUsersPasswordResetTfaRecoveryCodePost = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (
      params: DefaultApiUsersPasswordResetTfaRecoveryCodePostRequest
    ) => usersPasswordResetTfaRecoveryCodePost(axiosInstance, params),
  })
}
